import axios from 'axios'

import { createCollection } from './collection'

export default createCollection({
  fetchAll: {
    request: () => axios.get('/static/mock-data/drafts.json'),
    processResponse (response) {
      return response.data.data.reduce((collection, item) => {
        collection.ids.push(item.id)
        collection.entities[item.id] = item
        return collection
      }, { ids: [], entities: {}, loaded: true })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/modules/drafts.js